module.exports = __webpack_public_path__ + "img/minus_2.672403c0.svg";